import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreModule, MDS_TELEMETRY_INITIALIZERS } from '@mds/angular-core-material';
import { LayoutModule } from '@mds/angular-layout-material';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { InputMaxlengthDirective } from './components/input-maxlength.directive';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { LayoutComponent, TVP_BOTTOM_TOOLBAR } from './components/layout/layout.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { filterTelemetry } from './config/telemetry-filter';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { BrandingInterceptor } from './interceptors/branding.interceptor';
import { TimeoutInterceptor } from './interceptors/timeout.interceptor';
import { MaxlengthHintPipe } from './pipes/maxlength-hint.pipe';

@NgModule({
  declarations: [
    LayoutComponent,
    PageNotFoundComponent,
    InputMaxlengthDirective,
    MaxlengthHintPipe,
    LandingPageComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    LayoutModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    RouterModule,
    TranslateModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BrandingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutInterceptor,
      multi: true,
    },
    {
      provide: TVP_BOTTOM_TOOLBAR,
      useValue: new BehaviorSubject<boolean>(false),
    },
    {
      provide: MDS_TELEMETRY_INITIALIZERS,
      useValue: filterTelemetry,
      multi: true,
    },
  ],
  exports: [InputMaxlengthDirective, MaxlengthHintPipe],
})
export class TvpCommonModule {}
